export default __webpack_public_path__ + "static/media/juzgado.84614d74.jpg";